import { yemboApiCall } from '../_yemboApiCall';

// biome-ignore lint/suspicious/noExplicitAny: legacy API action interface
type ApiAction = Record<string, any>;

const url = 'initial-params';

export const postInitialParamsApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({ method: 'post', url, ...action });
